<template>
  <div >
    <div class="justify-content-center row ml-3" v-responsive.lg.xl>
         <div class="trigger ml-3" style="z-index: 1;">
        <span>
                                    <img class="mr-3" loading="lazy" src="../../../assets/img/writing.png" width="25px"  alt="writing quotes">

          <!-- <i style="font-size: 20px" class="mr-3 fa fa-file-text" aria-hidden="true"></i>  -->
          {{ $t('home_page.bouton_devis[0]') }} <i style="font-size: 20px"
                                                        class="ml-4 fas fa-chevron-down"></i></span>
        <ul class="devis elevation-24">
          <li class="font-weight-bold" style="cursor:pointer">{{ $t('home_page.particulier_label') }}</li>
          <li><a href="/devis/auto"><i><img class="mr-2" width="35"
                                            src="../../../assets/img/icones/menu/cars_quote.png"
                                            :alt="$t('home_page.bouton_devis[1]')"/></i>
            {{ $t('home_page.bouton_devis[1]') }}</a></li>
          <li><a href="/devis/habitation"><i><img class="mr-2" width="35"
                                                  src="../../../assets/img/icones/menu/house_quote.png"
                                                  :alt="$t('home_page.bouton_devis[2]')"/></i>
            {{ $t('home_page.bouton_devis[2]') }}</a></li>
          <li><a href="/devis/voyage"><i><img class="mr-2" width="35"
                                              src="../../../assets/img/icones/menu/travel_quote.png"
                                              :alt="$t('home_page.bouton_devis[3]')"/></i>{{
              $t('home_page.bouton_devis[3]')
            }}</a></li>
          <li><a href="/devis/sante"><i><img class="mr-2" width="35"
                                              src="../../../assets/img/icones/menu/health_quote.png"
                                              :alt="$t('home_page.bouton_devis[4]')"/></i>{{
              $t('home_page.bouton_devis[4]')
            }}</a></li>
          <li><a href="/devis/vie"><i><img class="mr-2" width="35"
                                            src="../../../assets/img/icones/menu/life_quote.png"
                                            :alt="$t('home_page.bouton_devis[5]')"/></i>{{
              $t('home_page.bouton_devis[5]')
            }}</a></li>
          <li><a href="/plus"><i><img class="mr-2" width="35" src="../../../assets/img/icones/menu/add_quote.png"
                                      :alt="$t('home_page.bouton_devis[6]')"/></i>{{
              $t('home_page.bouton_devis[6]')
            }}</a></li>
          <li class="font-weight-bold" style="cursor:pointer">{{ $t('home_page.entreprise_label') }}</li>
          <li><a href="/flotte/entreprise"><i><img class="mr-2" width="35" src="../../../assets/img/icones/menu/cars_quote.png" alt="flotte"/></i>{{ $t('menu.Devis[7]') }}</a></li>
          <li><a href="/devis/mrp"><i><img class="mr-2" width="30"
                                            src="../../../assets/img/icones/menu/mrp_quote.png"
                                            alt="devis_mrp"/></i> MRP</a></li>
          <li><a href="/devis/trc"><i><img class="mr-2" width="35"
                                            src="../../../assets/img/icones/menu/trc_quote.png"
                                            alt="devis_trc"/></i>TRC</a></li>
                                            <li><a href="/rcscolaire"><i><img class="mr-2" width="35" src="../../../assets/img/icones/rcscolaire.png" alt="flotte"/></i>{{ $t('menu.Devis[8]') }}</a></li>
        </ul>
      </div>
      <div class="trigger-simulation ml-4" style="z-index: 1;">
          <span>
                                      <img class="mr-3" loading="lazy" src="../../../assets/img/rocket.png" width="25px"  alt="writing quotes">

            <!-- <i style="font-size: 20px" class="mr-3 fa fa-file-text" aria-hidden="true"></i>  -->
            {{ $t('home_page.bouton_simulation_view') }} <i style="font-size: 20px"
                                                          class="ml-4 fas fa-chevron-down"></i></span>
          <ul class="devis elevation-24">
            <li><a href="/simulate/devis/auto"><i><img class="mr-2" width="35"
                                              src="../../../assets/img/icones/menu/cars_quote.png"
                                              :alt="$t('home_page.bouton_devis[1]')"/></i>
              {{ $t('home_page.bouton_devis[1]') }}</a></li>
            <li><a href="/simulate/devis/voyage"><i><img class="mr-2" width="35"
                                                src="../../../assets/img/icones/menu/travel_quote.png"
                                                :alt="$t('home_page.bouton_devis[3]')"/></i>{{
                $t('home_page.bouton_devis[3]')
              }}</a></li>
          </ul>
      </div>
    </div>

     <div v-responsive.sm.xs>
         <div class="trigger" style="position: relative;z-index: 2;">
        <span>
                                    <img class="mr-3" loading="lazy" src="../../../assets/img/writing.png" width="25px"  alt="writing quotes">

          <!-- <i style="font-size: 20px" class="mr-3 fa fa-file-text" aria-hidden="true"></i>  -->
          {{ $t('home_page.bouton_devis[0]') }} <i style="font-size: 20px"
                                                        class="ml-4 fas fa-chevron-down"></i></span>
        <ul class="devis elevation-24">
          <li class="font-weight-bold" style="cursor:pointer">{{ $t('home_page.particulier_label') }}</li>
          <li><a href="/devis/auto"><i><img class="mr-2" width="35"
                                            src="../../../assets/img/icones/menu/cars_quote.png"
                                            :alt="$t('home_page.bouton_devis[1]')"/></i>
            {{ $t('home_page.bouton_devis[1]') }}</a></li>
          <li><a href="/devis/habitation"><i><img class="mr-2" width="35"
                                                  src="../../../assets/img/icones/menu/house_quote.png"
                                                  :alt="$t('home_page.bouton_devis[2]')"/></i>
            {{ $t('home_page.bouton_devis[2]') }}</a></li>
          <li><a href="/devis/voyage"><i><img class="mr-2" width="35"
                                              src="../../../assets/img/icones/menu/travel_quote.png"
                                              :alt="$t('home_page.bouton_devis[3]')"/></i>{{
              $t('home_page.bouton_devis[3]')
            }}</a></li>
          <li><a href="/devis/sante"><i><img class="mr-2" width="35"
                                              src="../../../assets/img/icones/menu/health_quote.png"
                                              :alt="$t('home_page.bouton_devis[4]')"/></i>{{
              $t('home_page.bouton_devis[4]')
            }}</a></li>
          <li><a href="/devis/vie"><i><img class="mr-2" width="35"
                                            src="../../../assets/img/icones/menu/life_quote.png"
                                            :alt="$t('home_page.bouton_devis[5]')"/></i>{{
              $t('home_page.bouton_devis[5]')
            }}</a></li>
          <li><a href="/plus"><i><img class="mr-2" width="35" src="../../../assets/img/icones/menu/add_quote.png"
                                      :alt="$t('home_page.bouton_devis[6]')"/></i>{{
              $t('home_page.bouton_devis[6]')
            }}</a></li>
          <li class="font-weight-bold" style="cursor:pointer">{{ $t('home_page.entreprise_label') }}</li>
          <li><a href="/flotte/entreprise"><i><img class="mr-2" width="35" src="../../../assets/img/icones/menu/cars_quote.png" alt="flotte"/></i>{{ $t('menu.Devis[7]') }}</a></li>
          <li><a href="/devis/mrp"><i><img class="mr-2" width="30"
                                            src="../../../assets/img/icones/menu/mrp_quote.png"
                                            alt="devis_mrp"/></i> MRP</a></li>
          <li><a href="/devis/trc"><i><img class="mr-2" width="35"
                                            src="../../../assets/img/icones/menu/trc_quote.png"
                                            alt="devis_trc"/></i>TRC</a></li>
                                            <li><a href="/rcscolaire"><i><img class="mr-2" width="35" src="../../../assets/img/icones/rcscolaire.png" alt="flotte"/></i>{{ $t('menu.Devis[8]') }}</a></li>
        </ul>
      </div>
      <div class="trigger-simulation mt-4" style="position: relative;z-index: 1;">
          <span>
                                      <img class="mr-3" loading="lazy" src="../../../assets/img/rocket.png" width="25px"  alt="writing quotes">

            <!-- <i style="font-size: 20px" class="mr-3 fa fa-file-text" aria-hidden="true"></i>  -->
            {{ $t('home_page.bouton_simulation_view') }} <i style="font-size: 20px"
                                                          class="ml-4 fas fa-chevron-down"></i></span>
          <ul class="devis elevation-24">
            <li><a href="/simulate/devis/auto"><i><img class="mr-2" width="35"
                                              src="../../../assets/img/icones/menu/cars_quote.png"
                                              :alt="$t('home_page.bouton_devis[1]')"/></i>
              {{ $t('home_page.bouton_devis[1]') }}</a></li>
            <li><a href="/simulate/devis/voyage"><i><img class="mr-2" width="35"
                                                src="../../../assets/img/icones/menu/travel_quote.png"
                                                :alt="$t('home_page.bouton_devis[3]')"/></i>{{
                $t('home_page.bouton_devis[3]')
              }}</a></li>
          </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  methods : {
     /* Retourne true ou false si nous sommes sur un PC */
    isDesktop: function () {
      return screen.width > 768;
    },

     /* Retourne true ou false si nous sommes sur un PC */
     isTablette: function () {
      return screen.width  >425 <768;
    },
}
}

</script>

<style scoped>
.free-devis {
  min-width: 220px;
  cursor: pointer;
  position: relative;
}
.label-free-devis-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffa409;
  color: #000;
  font-weight: 700;
  height: 50px;
  border-radius: 10px;
  transition: border-radius 0.5s ease-in, color 0.5s ease-in-out;
}
.title-group {
  font-weight: 700;
}
.items {
  border-radius: 0 0 22px 22px;
  font-size: 14px;
  transform: scaleY(0);
  transform-origin: top;
  box-shadow:  0 11px 15px -7px rgba(0, 0, 0, .2), 0 24px 38px 3px rgba(0, 0, 0, .14), 0 9px 46px 8px rgba(0, 0, 0, .12);
  transition-delay: 0.5s;
  transition-duration: 0.2s;
  transition-property: transform;
  background-color: #fff;
  position: absolute;
  z-index: 1;
  width: 100%;
}
.free-devis:hover .label-free-devis-btn {
  border-radius: 22px 22px 0 0;
  color: #fff;
}

.free-devis:not(:hover) .label-free-devis-btn {
  transition-delay: 0.5s;
  transition-property: border-radius;
}

.free-devis:hover .items {
  transform: scaley(1);
}
.item {
  border-top: 1px solid #eee;
  padding: 0 18px;
  height: 44px;
  display: flex;
  align-items: center;
  transition: border-left 0.025s 0ms ease-out;
}
.item a{
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: #000;
}
.item:hover {
  border-left: 10px solid #eee;
}
.item:last-of-type {
  border-radius: 0 0 22px 22px;
}




.trigger {
  width: 240px;
}

.trigger span {
  width: 240px;
  font-weight: 500;
  letter-spacing: 0px;
  font-size: 15px;
  position: relative;
  background: #ffa409;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.trigger ul.devis {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  border-radius: 0 0 22px 22px;
  font-size: 14px;
  overflow: hidden;
  transform: scaley(0);
  transform-origin: top;
  transition: 150ms transform 150ms;
}

.trigger ul.devis a {
  opacity: 0;
  transition: 150ms opacity 0ms;
}

.trigger ul.devis li {
  top: 0;
  left: 0;
  width: 240px;
  height: 44px;
  padding: 0 20px;
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  border-left: 0px solid #eee;
  transition: 150ms border-left 0ms;
}

.trigger ul.devis li:before {
  content: '';
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, #eee, #fcfcfc);
  position: absolute;
  top: 0;
  left: 0;
}

.trigger ul.devis li:last-of-type {
  border-radius: 0 0 22px 22px;
}

.trigger ul.devis li a {
  text-decoration: none;
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
}

.trigger ul.devis li:hover {
  border-left: 10px solid #eee;
}

.trigger:hover span {
  border-radius: 22px 22px 0 0;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #fff;
}

.trigger:hover ul.devis {
  transform: scaley(1);
}

.trigger:hover ul.devis a {
  opacity: 1;
}









.trigger-simulation {
  width: 240px;
}

.trigger-simulation span {
  width: 240px;
  font-weight: 500;
  letter-spacing: 0px;
  font-size: 15px;
  position: relative;
  background: #5B94BC;
  color: #000;
  display: block;
  min-width: 0px;
  height: 50px;
  padding: 0 18px;
  z-index: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: 250ms border-radius 700ms, 700ms color 700ms, 350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.trigger-simulation ul.devis {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  border-radius: 0 0 22px 22px;
  font-size: 14px;
  overflow: hidden;
  transform: scaley(0);
  transform-origin: top;
  transition: 150ms transform 150ms;
}

.trigger-simulation ul.devis a {
  opacity: 0;
  transition: 150ms opacity 0ms;
}

.trigger-simulation ul.devis li {
  top: 0;
  left: 0;
  width: 240px;
  height: 44px;
  padding: 0 20px;
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  border-left: 0px solid #eee;
  transition: 150ms border-left 0ms;
}

.trigger-simulation ul.devis li:before {
  content: '';
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, #eee, #fcfcfc);
  position: absolute;
  top: 0;
  left: 0;
}

.trigger-simulation ul.devis li:last-of-type {
  border-radius: 0 0 22px 22px;
}

.trigger-simulation ul.devis li a {
  text-decoration: none;
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
}

.trigger-simulation ul.devis li:hover {
  border-left: 10px solid #eee;
}

.trigger-simulation:hover span {
  border-radius: 22px 22px 0 0;
  transition: 100ms border-radius 0ms, 100ms color 100ms, 350ms min-width 0ms;
  color: #fff;
}

.trigger-simulation:hover ul.devis {
  transform: scaley(1);
}

.trigger-simulation:hover ul.devis a {
  opacity: 1;
}
</style>